import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Equipment, EquipmentUtils } from 'src/app/bo/equipment';
import { Exploitation, ExploitationDataByEquipment } from 'src/app/bo/hiboo/exploitation';
import { BlastEquipmentsData } from 'src/app/bo/hiboo/getDataByBlastEquipmentsAndShift';
import { Shift } from 'src/app/bo/shifts/shift';
import { Tir } from 'src/app/bo/tir';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HibooService } from 'src/app/services/hiboo/hiboo.service';
import { TraductionService } from 'src/app/services/traduction.service';
import { StaticUtils } from 'src/app/utils/staticUtils';

@Component({
  selector: 'app-hiboo-dashboard-blast',
  templateUrl: './hiboo-dashboard-blast.component.html',
  styleUrls: ['./hiboo-dashboard-blast.component.scss'],
  standalone: false
})
export class HibooDashboardBlastComponent implements OnInit {
  @Input() tir: Tir;

  protected tabEquipments: Equipment[] = [];
  protected equipmentsSelectione: Equipment[] = [];
  protected selectedEquipment: Equipment;
  protected equipmentsExploitationCount: number;
  protected equipmentsExploitationData: ExploitationDataByEquipment[];
  protected ShiftList: Shift[];

  exploitation: Exploitation = undefined;
  today: Date = new Date();

  constructor(
    private readonly hibooService: HibooService,
    public fonctionsService: FonctionsService,
    private readonly translateService: TraductionService,
    public StaticUtils: StaticUtils
  ) {
  }

  ngOnInit(): void {
    this.hibooService.getShiftsByTirId(this.tir.siteId, this.tir.tirId).subscribe(shifts => {
      this.ShiftList = shifts;
      if (this.ShiftList && this.ShiftList.length > 0) {
        this.getEquipmentsBySiteId();
      } else {
        this.exploitation = null;
        this.equipmentsExploitationData = [];
        this.equipmentsExploitationCount = 0;
        console.warn('ShiftList is empty or undefined.');
      }
    }, error => {
      console.error('Error fetching shifts', error);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tir'] && !changes['tir'].firstChange) {
      this.hibooService.getShiftsByTirId(this.tir.siteId, this.tir.tirId).subscribe(shifts => {
        this.ShiftList = shifts;
        if (this.ShiftList && this.ShiftList.length > 0) {
          this.getEquipmentsBySiteId();
        } else {
          this.exploitation = null;
          this.equipmentsExploitationData = [];
          this.equipmentsExploitationCount = 0;
          console.warn('ShiftList is empty or undefined on tir change.');
        }
      }, error => {
        console.error('Error fetching shifts on tir change', error);
      });
    }
  }

  ngOnDestroy(): void {
  }

  getEquipmentsBySiteId() {
    this.hibooService.getEquipmentsBySiteId(this.tir.siteId).subscribe({
      next: (result) => {
        this.tabEquipments = result;
        this.tabEquipments.forEach(element => {
          element.displayName = this.translateService.instant(EquipmentUtils.getEquipmentType(element.externalId)) + " - " + EquipmentUtils.formatEquipmentDisplayName(element);
        });
        if (this.tabEquipments.length > 0) {
          this.equipmentsSelectione = [...this.tabEquipments];
          this.fetchExploitationDataByEquipments();
        }else {
          this.exploitation = null;
          this.equipmentsExploitationData = [];
          this.equipmentsExploitationCount = 0;
          console.warn('No equipments found.');
        }
      },
      error: (error) => {
        console.error(error);
        this.exploitation = null;
        this.equipmentsExploitationData = [];
        this.equipmentsExploitationCount = 0;
      }
    })
  }

  fetchExploitationDataByEquipments() {
    if (this.ShiftList === null || this.ShiftList === undefined || this.ShiftList.length === 0) {
      return;
    }

    const externalIds = this.equipmentsSelectione.map(equipment => equipment.externalId);
    const blastData = new BlastEquipmentsData();
    blastData.tirId = this.tir.tirId;
    blastData.equipmentIds = externalIds;

    this.fonctionsService.loading_screen(true);
    this.hibooService.getExploitationDataByTirEquipmentsAndTime(this.tir.siteId, blastData)
      .subscribe({
        next: (exploitationResult) => {
          this.UpdateExploitationMetrics(exploitationResult);
          this.fonctionsService.loading_screen(false);
        },
        error: (error) => {
          console.error(error);
          this.fonctionsService.launch_toast(false);
          this.fonctionsService.loading_screen(false);
        }
      });
  }

  private UpdateExploitationMetrics(exploitation: Exploitation){
    if (!exploitation) {
      console.error('Exploitation data is null or undefined.');
      return; 
    }

    this.exploitation = exploitation;
    if (this.exploitation) {
      this.exploitation.operatingPercent = ((exploitation.operatingHours / exploitation.operatingHours) * 100).toFixed(2);
      this.exploitation.usagePercent = ((exploitation.usageHours / exploitation.operatingHours) * 100).toFixed(2);
      this.exploitation.idlePercent = ((exploitation.idleHours / exploitation.operatingHours) * 100).toFixed(2);
      this.exploitation.hourlyConsumption = (exploitation.fuelUsed / exploitation.operatingHours).toFixed(2);
      this.exploitation.co2EmissionsRate = (exploitation.co2/exploitation.fuelUsed).toFixed(2);
      if (exploitation.exploitationDataByEquipmentIds !== null && exploitation.exploitationDataByEquipmentIds !== undefined){
        this.equipmentsExploitationCount = Object.keys(exploitation.exploitationDataByEquipmentIds).length;
      }
      
      this.equipmentsExploitationData = this.fetchEquipmentsData(exploitation, this.tabEquipments);
    }
  }

  private fetchEquipmentsData(exploitationData: Exploitation, equipments: Equipment[]): ExploitationDataByEquipment[] {
    if (!equipments || !Array.isArray(equipments) || equipments.length === 0) {
      console.error('Equipments array is undefined, not an array, or empty.');
      return [];
    }

    const equipmentMap = new Map<number, Equipment>();
    for (const equipment of equipments) {
      equipmentMap.set(equipment.externalId, equipment);
    }

    const updatedExploitationData: ExploitationDataByEquipment[] = [];
    if (exploitationData.exploitationDataByEquipmentIds && Object.keys(exploitationData.exploitationDataByEquipmentIds).length > 0 ) {
      Object.entries(exploitationData.exploitationDataByEquipmentIds).forEach(([key, element]) => {
        const equipmentId = Number(key);
        const equipment = equipmentMap.get(equipmentId);
        if (equipment) {
          element.equipementDisplayName = equipment.displayName;
        } else {
          console.error(`Equipment with ID ${equipmentId} not found in the selected equipment list.`);
        }
        updatedExploitationData.push(element);
      });
    }
    
    return updatedExploitationData;
  }

  getDateFormat(): string {
    return StaticUtils.getDateFormat(this.translateService.translate.currentLang);
  }

  getDateWithTimeFormat(): string {
    return StaticUtils.getDateWithTimeFormat(this.translateService.translate.currentLang);
  }

  getDatePickerDateFormat(): string {
    return StaticUtils.getDatePickerDateFormat(this.translateService.translate.currentLang);
  }
}
